import type { ReactNode } from "react";

import { BlurView } from "expo-blur";
import { Image } from "expo-image";
import { StyleSheet, View, type ViewStyle } from "react-native";

import { colors } from "@/constants/colors";

export function DarkBlurCard({
  children,
  imageUrl,
  style,
}: {
  children?: ReactNode;
  imageUrl?: null | string;
  style?: ViewStyle;
}) {
  return (
    <View
      style={[
        {
          backgroundColor: colors.darkOverlay,
          borderRadius: 24,
          overflow: "hidden",
        },
        style,
      ]}
    >
      {imageUrl && (
        <Image
          contentFit="cover"
          source={{ uri: imageUrl }}
          style={StyleSheet.absoluteFill}
        />
      )}
      <BlurView intensity={40} style={StyleSheet.absoluteFill} tint="dark" />
      {children}
    </View>
  );
}
